/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentControllerNextCode200ResponseData { 
    companyId?: string;
    areaId?: string;
    typeId?: string;
    areaCode?: string;
    typeCode?: string;
    sequence?: number;
    /**
     * Código armado, ej. OPE-001-PR
     */
    code?: string;
}

